module.exports = __webpack_public_path__ + "static/media/icon-arrow-big.87c333cf.svg";